import { API } from "@/services"

export const DATA_CENTER_ENDPOINTS = {
  create(netword_id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `network/${netword_id}/data-center`,
      method: 'POST',
      data,
      timeout: 3*60*1000,
    })
  },
  findById(netword_id='',id,params={}){
    return API.Axios.error_capture.v1.request({
      url: `network/${netword_id}/data-center/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(netword_id='',id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `network/${netword_id}/data-center/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(netword_id='',id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `network/${netword_id}/data-center/${id}`,
      method: 'PUT',
      data,
      timeout: 3*60*1000,
    })
  },
  updateSystemInfo(netword_id='',id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `network/${netword_id}/data-center/${id}/system-info`,
      method: 'PATCH',
      data,
      timeout: 3*60*1000,
    })
  },
}